// extracted by mini-css-extract-plugin
module.exports = {"audios":"style_audios__uY4Mh","audio":"style_audio__2S4iK","delete_button":"style_delete_button__2CTFy"};